export const TOKEN = '@SPEDValidation:TOKEN'
export const USUARIO = '@SPEDValidation:USUARIO'
export const PERFIL = '@SPEDValidation:PERFIL'
export const PERMISSOES = '@SPEDValidation:PERMISSOES'

export const ID_TELA_DE_CEST = '0301f13a-b74d-46d1-b436-d0a76fa77205'
export const ID_TELA_DE_CFOP = '5932c8b8-4f4f-48c0-950e-d7ce6bbba68d'
export const ID_TELA_DE_CST = 'd9b3ae15-d57f-41d1-ae7e-99ebd989036c'
export const ID_TELA_DE_EMPRESA = 'db3a0b74-8e27-4ea8-81f1-2a08d42721f8'
export const ID_TELA_DE_FORNECEDOR = '8973de30-dce4-43f1-959c-65bd2dbb9446'
export const ID_TELA_DE_ICMS = '83d1181a-9a75-443f-a102-e0face97ab34'
export const ID_TELA_DE_ITENS_VO = 'da81cba6-e9c4-4d16-a47f-432ce5c9114f'
export const ID_TELA_DE_LEI = '9420789f-aac7-4759-a06c-0fc64713188d'
export const ID_TELA_DE_NATUREZA = 'e7a29b01-01ad-43e4-8ce2-e093c2bfd4b4'
export const ID_TELA_DE_NCM = '9240ad68-7767-43a2-9b9d-380d675c3e91'
export const ID_TELA_DE_NESH = 'eb2f22fb-012a-42fa-87e3-bd00547a10a1'
export const ID_TELA_DE_PISCOFINS = '9c47b75c-226d-4f29-8d64-d164ac6f5982'
export const ID_TELA_DE_SEGMENTO = '752f9a99-a11f-45ea-b4f2-a0a7eb6b525c'
export const ID_TELA_DE_TIPO_ICMS = '47067760-e19a-41bc-8872-8a8e5989f8dd'
export const ID_TELA_DE_IPI = '703f3199-7683-4d99-8989-fc395e910fce'
export const ID_TELA_DE_PERFIS = 'b2bd4c3c-76fd-43f7-a651-f44edda48f4b'
export const ID_TELA_DE_PERMISSOES = '0e873e84-2084-478c-bf30-6bd1640efe2e'
export const ID_TELA_DE_USUARIOS = '58abe691-e583-4d7d-96f2-f695f0c81f7b'
export const ID_TELA_DE_ATUALIZACOES = 'effe9cfb-7319-4138-89dd-075d40847b22'
export const ID_TELA_DE_ENTRADAS = '1ed341ef-8b6a-4420-8012-268dfcbd9fc4'
export const ID_TELA_DE_SAIDAS = '4e738c90-14ed-482a-a0cf-dc05374882f9'
export const ID_TELA_DE_ITENS_CLIENTE = '0fee1f3b-2027-4e08-bd45-1ce6625cbcf9'
export const ID_TELA_DE_NFES = 'ad513e28-d665-41ec-9508-be7e911dea3c'
export const ID_TELA_DE_FILIAL = ''
